import React from 'react'

import styled from '@emotion/styled'
import { Box, useTheme, BoxProps } from '@gousto-internal/citrus-react'

export const CarouselBoxWrapper = (props: BoxProps) => {
  const { theme } = useTheme()

  const largeBreakpoint = theme.tokens.breakpoints[1]
  const breakpointToLarge = `@media (min-width: ${largeBreakpoint})`

  const Component = styled(Box)({
    '&:first-of-type': {
      marginBottom: '24px',
    },

    [breakpointToLarge]: {
      '&:first-of-type': {
        marginRight: '24px',
        marginBottom: 0,
      },
    },
  })

  // eslint-disable-next-line react/jsx-props-no-spreading
  return <Component {...props} />
}
